const SKIP_LOGIN = "skipLogin";

export function markLoginSkipped() {
  window.sessionStorage.setItem(SKIP_LOGIN, true);
}

export function wasLoginSkipped() {
  return window.sessionStorage.getItem(SKIP_LOGIN);
}
